import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "London 3",
  "description": "",
  "published": "2007-09-21T00:00:00.000Z",
  "redirect_from": ["/blog/london-3/swizec/153"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Zaradi lenobe se prosim obrnite na `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/lang=en"
      }}>{`anglesko verzijo`}</a>{` tega teksta, ki je takoalitako bolje spisana kot bi bila ta, saj je pisanje v drugic malcek utrujajoce in se vcasih kaj spusti ali pozabi in potem tekst izgubi svoj sarm.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      